// deps
import React, { ReactElement, memo, useContext } from "react";

// context
import { ApiContext, GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { EmiSelectionContext } from "@payment-client/contexts/EmiSelectionContext";
import { AnalyticsContext } from "@swiggy-private/checkout-core";

// widgets
import ErrorScreen from "./widgets/ErrorScreen";
import Content from "./widgets/Content";

// interfaces
import type { RouteProps } from "@payment-client/interfaces/Router";

// helper
import { reviewBillDetailsLandingScreen } from "./helpers/analytics";

// hooks
import { useEffectOnce } from "@swiggy-private/core-ui";
import { useFetchBillDetails } from "./hooks/useFetchBillDetails";

type ReviewBillDetailsRendererProps = RouteProps;

function ReviewBillDetailsRenderer(_: ReviewBillDetailsRendererProps): ReactElement | null {
    const apiContextValue = useContext(ApiContext);
    const { screenViewEvent } = useContext(AnalyticsContext);
    const { selectedEmiDetails } = useContext(EmiSelectionContext);
    const apiHost = apiContextValue.host.unwrap();
    const { data, loading, error } = useFetchBillDetails({ apiHost, selectedEmiDetails });

    useEffectOnce(() => {
        const cartId = GlobalHeaderState.getHeader(SwgyHeaderKeysList.cartId) ?? "";
        const planId = GlobalHeaderState.getHeader(SwgyHeaderKeysList.planid) ?? "";
        reviewBillDetailsLandingScreen(screenViewEvent, { cartId, planId });
    });

    if (error) {
        return <ErrorScreen />;
    }

    return <Content data={data} loading={loading} />;
}

export default memo(ReviewBillDetailsRenderer);
